import { Descriptions } from 'antd';
import {
  ElectricityDescriptionsDetails,
  getElectricityDetailDescriptions,
} from 'components/descriptions/meter_details/electricity';
import { getGasDetailDescriptions } from 'components/descriptions/meter_details/gas';
import {
  getThermalDetailDescriptions,
  ThermalDescriptionsDetails,
} from 'components/descriptions/meter_details/thermal';
import { getOtherDetailDescriptions } from 'components/descriptions/meter_details/other';
import { getWaterDetailDescriptions, WaterDescriptionsDetails } from 'components/descriptions/meter_details/water';
import { meterMountTypeTranslated, commodityTranslated } from 'components/Form/meter_details/constants';
import { useMeterContext } from 'contexts/Meter';
import { useCallback, VFC } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useReplaceMeterStore } from 'routes/meter_replacement/useStore';
import { MeterDetailGas, MeterDetailOther } from '@enmon/commons/lib/enmon';
import { Commodity } from '@enmon/commons/lib/shared';
import { DetailsDescriptions as messages } from '../messages';
import { outputTechnologyTranslated } from '../../../../../components/Form/meter_details/messages';

export const DetailsDescriptions: VFC = () => {
  const intl = useIntl();
  const { enmonMeter } = useMeterContext();
  const { commodity } = enmonMeter ?? {};
  const { detail, meterMountType, meterMountTechnology, internalNote } = useReplaceMeterStore();

  const getDetailDescriptions = useCallback(() => {
    switch (commodity) {
      case Commodity.Thermal: {
        return getThermalDetailDescriptions(detail as ThermalDescriptionsDetails, intl);
      }
      case Commodity.Water: {
        return getWaterDetailDescriptions(detail as WaterDescriptionsDetails, intl);
      }
      case Commodity.Electricity: {
        return getElectricityDetailDescriptions(detail as ElectricityDescriptionsDetails, intl);
      }
      case Commodity.NaturalGas: {
        return getGasDetailDescriptions(detail as MeterDetailGas, intl);
      }
      case Commodity.Other: {
        return getOtherDetailDescriptions(detail as MeterDetailOther, intl);
      }
      default:
        console.error(`Third step with unknown commodity: ${commodity ?? 'undefined'}`);
        return null;
    }
  }, [intl, commodity, detail]);

  return (
    <Descriptions
      bordered
      column={{ xxl: 2, xl: 2, lg: 2, md: 2, sm: 1, xs: 1 }}
      size="small"
      title={<FormattedMessage {...messages.title} />}
    >
      <Descriptions.Item label={<FormattedMessage {...messages.commodity} />}>
        {commodity ? intl.formatMessage(commodityTranslated[commodity]) : ''}
      </Descriptions.Item>
      <Descriptions.Item label={<FormattedMessage {...messages.installationStatus} />}>
        {meterMountType ? intl.formatMessage(meterMountTypeTranslated[meterMountType]) : ''}
      </Descriptions.Item>
      <Descriptions.Item label={<FormattedMessage {...messages.meterMountTechnology} />}>
        {meterMountTechnology ? intl.formatMessage(outputTechnologyTranslated[meterMountTechnology]) : ''}
      </Descriptions.Item>
      {getDetailDescriptions()}
      <Descriptions.Item label={<FormattedMessage {...messages.note} />}>{internalNote}</Descriptions.Item>
    </Descriptions>
  );
};
